import React from 'react';

import AdminIntegrationEdit from './Edit';

// Thin wrapper so that /integrations/new resolves to a dedicated component
// rather than re-using the Edit page directly. The underlying Edit component
// already handles the "new" case via useParams (id undefined => isNew === true).
export default function AdminIntegrationNew() {
  return <AdminIntegrationEdit />;
}
